import styles from "./navigation-bar.module.css";
import { MainAppMenu } from "./main-app-menu/main-app-menu";
import { usePaths } from "BEDROCK/paths";

interface NavigationBarProps {}

export const NavigationBar = (props: NavigationBarProps) => {
  return (
    <div className={styles.container}>
      <LeadingContent />
      <TrailingContent />
    </div>
  );
};

const LeadingContent = () => {
  const { home, navigateTo } = usePaths();

  return (
    <div className={styles.leadingContent}>
      <button
        className={styles.logo}
        onClick={() => {
          navigateTo(home);
        }}
      >
        <img src="/logo/LOGO.png" alt="Admin logo" />
      </button>
    </div>
  );
};

const TrailingContent = () => {
  return (
    <div className={styles.trailingContent}>
      <MainAppMenu />
    </div>
  );
};
